<template>
	<div class="full">
		<el-container class="full" v-loading="loading">
			<el-container>
				<el-container>
					<el-main>
						<!-- <el-tag type="danger" size="mini">上午10点后更新</el-tag> -->
						<div class="table flex">
							<el-switch style="padding-left:20px" v-model="showFlowup" @change="flowupChange" active-text="只显示自己跟踪" inactive-text=""></el-switch>
							<div style="position: relative;flex: 1;">
								<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" ref="bishopgoods"
									@toolbar-button-click="list_toolbarButtonClickEvent" @cell-click="cellClick"></vxe-grid>
							</div>
						</div>
						<div class="footer">
							<operateIndex :row="currentrow" />
						</div>
					</el-main>
				</el-container>
			</el-container>
		</el-container>
		<singleIndex :currentrow="currentrow" ref="singleIndex"  />
	</div>
</template>
<style>

</style>
<style scoped>
	.table {
		position: relative;
		width: 100%;
		height: 70%;
		flex-direction: column;
	}

	.footer {
		position: relative;
		width: 100%;
		height: 30%;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import operateIndex from './operate/index.vue'
	import singleIndex from './single/index.vue'
	export default {
		mixins: [listMixins],
		name: 'bi',
		props: {

		},
		data() {
			return {
				showFlowup:false,
				parcentField:['payAmt','sucRefundAmt','newPayByrCnt','payOldByrCnt','payTotalByrCnt','payRate','itmUv','seGuideUv','seGuidePayByrCnt','seGuidePayRate','uvValue','payPct','charge','chargePercent'],
				loading: false,
				tableData: [],
				historytableData:[],
				childrenRow: null,
				selectTab: '',
				shopnameOptions: [],
				formField: {
					shopname: [],
					psnNickName: [],
					code: '',
					title: ''
				},
				list_formConfig: [{
					field: 'shopname',
					title: '店铺名称',
					slots:{
						default:(params)=>{
							return <el-cascader v-model={params.data.shopname} size="mini" collapse-tags options={this.shopnameOptions} show-all-levels={false} props={{multiple: true, checkStrictly: false}} clearable></el-cascader>
						}
					}
				},{
					field: 'code',
					title: '商品编码',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'title',
					title: '商品名称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'datetime',
					title: '日期',
					itemRender: {
						name: '$datePicker'
					}
				}],
				currentrow:null,
				other:{}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			// this.gridOptions = this.getOption()
			// console.log(this.gridOptions)
		},
		computed: {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.id = 'bIshopgoods'
				gridOptions.showOverflow = false
				gridOptions.columns = this.getColumns()
				gridOptions.exportConfig = {
					name: '导出',
					type: 'xlsx',
					exportMethod:this.exportMethod,
					remote:true
				}
				// gridOptions.scrollY = {
				// 	enabled:false
				// }
				gridOptions.tooltipConfig.contentMethod = this.contentMethod
				gridOptions.pagerConfig = {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500, 5000],
				}
			},
			exportMethod(e){
				return new Promise((resolve) => {
					let options = JSON.parse(JSON.stringify(e.options))
					let fullData = JSON.parse(JSON.stringify(this.sourceData))
					fullData.forEach((item)=>{
						item.type = null
					})
					options.remote = false
					options.data = fullData
					this.$refs.bishopgoods.exportData(options)
					resolve()
					
					
					// let pager = e.$grid.getProxyInfo().pager				
					// this.$api.BIshopgoods.export({
					// 	currentPage:-1,
					// 	pageSize:pager.pageSize
					// }).then((res)=>{
					// 	let options = JSON.parse(JSON.stringify(e.options))
					// 	res.tableData.forEach((item)=>{
					// 		item.type = null
					// 	})
					// 	options.data = res.tableData
					// 	options.remote = false
					// 	this.$refs.bishopgoods.exportData(options)
					// 	resolve()
					// })
				});
				
			},
			list(page, updateForm) {
				return new Promise((resolve) => {
					this.$api.BIshopgoods.get({
						...page,
						...updateForm,
						...this.other,
					}).then((res) => {
						res.tableData.forEach((item) => {
							item.payPct = 0
							if (item.payTotalByrCnt) {
								item.payPct = (item.payAmt / item.payTotalByrCnt).toFixed(2)
							}
							item.itemCost = item.costdetail?item.costdetail.itemCost:null
						})
						res.historytableData.forEach((item) => {
							item.payPct = 0
							if (item.payTotalByrCnt) {
								item.payPct = (item.payAmt / item.payTotalByrCnt).toFixed(2)
							}
						
						})
						this.sourceData = JSON.parse(JSON.stringify(res.tableData))
						this.historytableData = res.historytableData
							
						this.shopnameOptions = res.formField.shopname
						if (this.shopnameOptions.length != 0) {
							this.selectTab = this.shopnameOptions[0].value
						}
						let list = this.createTableData()
						list.forEach((item)=>{
							let percentinfo = {}
							this.parcentField.forEach((_item)=>{
								percentinfo[_item] = this.getpercent(item,_item)
							})
							item.percent = percentinfo
						})
				
						this.currentrow = null
						resolve({
							list: list,
							total: res.total
						})
					}, () => {
						resolve()
					})
				})
			},
			contentMethod({row,column}){
				if(row && this.parcentField.indexOf(column.field)!==-1){
					return '本周期：' + row[column.field] + '\n上周期：'+row.percent[column.field].value + '\n浮动：'+row.percent[column.field].text
				}else{
					return null
				}
				
			},
			cellClick({row,column}){
				this.currentrow = row
				if(column.field=='code'){
					this.$nextTick(()=>{
						this.$refs.singleIndex.drawer_show()
					})
				}
			},
			flowupChange(e){
				this.other.showFlowup = e?1:0
				this.$refs.bishopgoods.commitProxy('query')
			},
			getColumns() {
				let columns = [{
						field: 'shopname',
						title: '店铺',
						sortable: true,
						showOverflow:true,
					},
					{
						field: 'code',
						title: '商品编码',
						width:150,
						slots : {
							default: ({row}) => {									
								//let currenttime = new Date().getTime()/1000
								let str = []
								if(row.needflowuptime == 1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">跟</el-tag>)
								}
								str.push(<el-link style="font-size:12px;" type="primary">{row.code}</el-link>)
								return str
							}
						}
					},
					{
						field: 'title',
						title: '名称',
						sortable: true,
						showOverflow:true,
					},
					{
						field: 'payAmt',
						title: '支付金额',
						sortable: true
					},
					{
						
						field: 'sucRefundAmt',
						title: '成功退款金额',
						sortable: true,
					},
					{
						field: 'newPayByrCnt',
						title: '支付新买家数',
						sortable: true
					},
					{
						field: 'payOldByrCnt',
						title: '支付老买家数',
						sortable: true
					},
					
					{
						field: 'payTotalByrCnt',
						title: '支付总人数',
						sortable: true
					},
					{
						field: 'payRate',
						title: '支付转化率',
						sortable: true
					},
					{
						field: 'itmUv',
						title: '商品访客数',
						sortable: true
					},
					{
						field: 'seGuideUv',
						title: '搜索访客数',
						sortable: true
					},
					{
						field: 'seGuidePayByrCnt',
						title: '搜索支付买家数',
						sortable: true
					},
					{
						field: 'seGuidePayRate',
						title: '搜索支付转化率',
						sortable: true,
						formatter: ({
							cellValue
						}) => {
							return cellValue + '%'
						}
					},
					{
						field: 'uvValue',
						title: 'UV价值',
						sortable: true
					},
					{
						field: 'payPct',
						title: '客单价',
						sortable: true
					},
					{
						field: 'charge',
						title: '花费',
						sortable: true
					},
					{
						field: 'chargePercent',
						title: '花费占比',
						sortable: true,
						formatter: ({
							cellValue
						}) => {
							return cellValue + '%'
						}
					},
					{
						field: 'itemCost',
						title: '发货成本',
						slots: {
							default:({row})=>{
								return	<div>
									<div style="font-weight:bolder;display:inline-block;font-size:14px">{row.itemCost}</div>
								</div>
							}
						}
					},		
					{
						field: 'flowuptime',
						title: '最近跟踪时间',
						width:100,
						fixed:'right',
						formatter: ({
							cellValue
						}) => {
							return window.systemMethods.timestampToDate(cellValue,true)
						},
						sortable:true
					},
					//{field:'date',title:'日期',sortable:true},
				]
				columns.forEach((item)=>{
					item.showHeaderOverflow = 'tooltip'
					if(this.parcentField.indexOf(item.field)!==-1){
						item.slots = {
							default:({row})=>{
								return	<div>
									<div style="font-weight:bolder;display:inline-block;font-size:14px">{row[item.field]}</div>
									<div style={{color:row.percent[item.field].color}}>{row.percent[item.field].text}</div>
								</div>
							}
						}
					}
				})
				return columns
			},
			getpercent(row,field){
				let percent = ''
				let obj = this.historytableData.find((item)=>{
					return item.code == row.code
				})
				if(obj){
					if(obj[field]){
						percent = ((parseFloat(row[field]) - parseFloat(obj[field]))/obj[field]*100).toFixed(2)
					}	
				}
				percent = !isNaN(percent)?percent:''
				let result = {
					value:obj?obj[field]:0,
					percent:percent?Math.abs(percent):'',
					type:percent?(percent>0?'up':'down'):'none',
					color:percent?(percent>0?'#F56C6C':'#67C23A'):'none'
				}
				if(result.type=='up'){
					result.text = '↑ ' + result.percent+'%'
				}
				if(result.type=='down'){
					result.text = '↓ ' + result.percent+'%'
				}				
				return result
			},
			// getProx() {
			// 	let proxyConfig = {
			// 		ajax: {
			// 			query: ({
			// 				page,
			// 			}) => {
			// 				let updateForm = JSON.parse(JSON.stringify(this.formData))
			// 				for (let i in updateForm) {
			// 					if (i.match(/.*time$/g)) {
			// 						if (typeof updateForm[i] === 'string') {
			// 							updateForm[i] = updateForm[i].split(',')
			// 						}
			// 						if (typeof updateForm[i] === 'number') {
			// 							if (updateForm[i] > 1000000000000) {
			// 								updateForm[i] = updateForm[i] / 1000
			// 							}
			// 						} else if (Array.isArray(updateForm[i])) {
			// 							let timerange = updateForm[i]
			// 							timerange.forEach((t, i) => {
			// 								if (t > 1000000000000) {
			// 									timerange[i] = t / 1000
			// 								} else {
			// 									timerange[i] = t
			// 								}

			// 							})
			// 							updateForm[i] = updateForm[i].join(',')
			// 						}
			// 					} else {
			// 						if (Array.isArray(updateForm[i])) {
			// 							updateForm[i] = updateForm[i].join(',')
			// 						}
			// 					}
			// 				}
			// 				return new Promise(resolve => {
			// 					this.$api.BIshopgoods.get({
			// 						...page,
			// 						...updateForm
			// 					}).then((res) => {
			// 						res.tableData.forEach((item) => {
			// 							item.payPct = 0
			// 							if (item.payTotalByrCnt) {
			// 								item.payPct = (item.payAmt / item
			// 									.payTotalByrCnt).toFixed(2)
			// 							}

			// 						})
			// 						this.sourceData = res.tableData
			// 						this.shopnameOptions = res.formField.shopname
			// 						if (this.shopnameOptions.length != 0) {
			// 							this.selectTab = this.shopnameOptions[0].value
			// 						}

			// 						let resolveobj = {
			// 							result: this.createTableData(),
			// 							page: {
			// 								total: res.total
			// 							}
			// 						}
			// 						resolve(resolveobj)
			// 					}, () => {
			// 						resolve()
			// 					})
			// 				})
			// 			}
			// 		}
			// 	}
			// 	return proxyConfig

			// },
			createTableData() {
				let tableData = JSON.parse(JSON.stringify(this.sourceData))
				return tableData
			},
			submitEvent() {
				this.$refs.shopgoods.commitProxy('query')
			},
			reset() {
				for (let i in this.formData) {
					this.formData[i] = null
				}
				this.$refs.shopgoods.getProxyInfo().pager.currentPage = 1
				this.$refs.shopgoods.commitProxy('query')

			},
			href(url) {
				window.location.href = url
			}
		},
		components: {
			operateIndex,
			singleIndex
		}
	}
</script>